const Lang = require('lang');
const confirm = require('../events/confirm');
const GlobalAlerts = require('global_alerts');

/**
 * Valor do timer usado para fazer o
 * balanceamento do do disparo do
 * evento de keyup
 *
 * @type {Number}
 */
let keyupTimer = 0;

/**
 * Número de casas decimais que estamos usando nas conversões
 */
const decimalPlaces = 5;

/**
 * Aplicar interação e realização de
 * cálculo de Moeda Estrangeira
 */
function MoedaEstrangeira() {
  nifty.body.overlay({
    fixed: true
  });

  settings();
}

/**
 * Configuração do js da funcionalidade
 * de moeda estrangeira realiza a aplicação
 * dos listeners e os demias itens que são
 * necessários
 */
function settings() {
  $('[data-mask="currency-exchange"]').mask(
    '000.000.000.000.000,00000',
    { reverse: true }
  );

  applyListenerSubmit();
  applyListenerInputExchangeRate();
  applyListenerInputExchangeGroup();
  applyListenerButtonEnableEditExchange();
  applyListenerInputExchangeTotalAmmount();
}

/**
 * Identificar e aplicar os listeners dos botões
 * de submit do formulário
 */
function applyListenerSubmit() {
  const buttons = document.querySelectorAll('[data-button-exchange-rate]');
  buttons.forEach((currentButton) => {
    currentButton.addEventListener('click', handlerSubmitForm);
  });
}

/**
 * Identificar e aplicar o listener para todas
 * as inputs de taxa que são dos agrupamentos
 * por moeda
 */
function applyListenerInputExchangeGroup() {
  const inputs = document.querySelectorAll('[data-expense-group-exchange]');
  inputs.forEach((currentInput) => {
    const isBlocked = checkBlockedGroupExchangeInput(currentInput);

    if (isBlocked) {
      return;
    }

    currentInput.addEventListener('keyup', (event) => {
      if (!validKeyPress(event)) { return };
      keyupEvent(event, handlerInputExchangeGroup);
    });

    currentInput.addEventListener('paste', (event) => {
      keyupEvent(event, handlerInputExchangeGroup);
    });
  });
}

/**
 * Identificar e aplicar o listener para todas
 * as inputs de taxa
 */
function applyListenerInputExchangeRate() {
  const inputs = document.querySelectorAll('[data-expense-exchange-rate]');
  inputs.forEach((currentInput) => {
    applyValue(currentInput);
    currentInput.addEventListener('keyup', (event) => {
      if (!validKeyPress(event)) { return };
      keyupEvent(event, handlerInputExchangeRate);
    });

    currentInput.addEventListener('paste', (event) => {
      keyupEvent(event, handlerInputExchangeRate);
    });
  });
}

/**
 * Identificar e aplicar o listener para todas
 * as inputs de total da despesa
 */
function applyListenerInputExchangeTotalAmmount() {
  const inputs = document.querySelectorAll('[data-expense-total-ammount]');
  inputs.forEach((currentInput) => {
    applyValue(currentInput);
    currentInput.addEventListener('keyup', (event) => {
      if (!validKeyPress(event)) { return };
      keyupEvent(event, handlerInputExchangeTotalAmmount);
    });

    currentInput.addEventListener('paste', (event) => {
      keyupEvent(event, handlerInputExchangeTotalAmmount);
    });
  });
}

/**
 * Identificar e aplicar o listener para todos os
 * botões de desbloquear inputs para alterações
 */
function applyListenerButtonEnableEditExchange() {
  const buttons = document.querySelectorAll('[data-expense-enable-edit="true"]');
  buttons.forEach((currentButton) => {
    currentButton.addEventListener('click', handlerEnableEditExchange);
  });
}

/**
 * Realiza a chamada da request para salvar
 * os taxas das despesas, com base no retorno
 * injeta o código html dentro da divi de
 * conteúdo de despesas e exibe o toast
 *
 * @param  {event} event
 */
function handlerSubmitForm(event) {
  const divContent = document.querySelector('#despesas-content');
  const form = event.target.closest('form');
  const inputsHabilitadas = form.querySelectorAll('[data-expense-exchange-rate]:not(:disabled)');

  // validando se temos dados para serem enviados
  // (inputs que não estejam desabilitadas)
  if (!inputsHabilitadas.length) {
    GlobalAlerts.createAndShow({
      type: 'warning',
      title: Lang.get('js/src/functions/MoedaEstrangeira.warning_title'),
      message: Lang.get('js/src/functions/MoedaEstrangeira.warning_message'),
    });
    return;
  }

  nifty.body.overlay('show');
  sendRequest(form)
    .done(function (data) {
      divContent.innerHTML = data.html;
      if (data.success) {
        settings();
        GlobalAlerts.createAndShow({
          title: Lang.get('js/src/functions/MoedaEstrangeira.success_title'),
          message: Lang.get('js/src/functions/MoedaEstrangeira.success_message'),
        });
        return;
      }
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/src/functions/MoedaEstrangeira.error_title'),
        message: Lang.get('js/src/functions/MoedaEstrangeira.error_message'),
      });
      defineBackValuesWithError(data.valoresInformadosComErro);
      settings();
    })
    .fail(function () {
      GlobalAlerts.createAndShow({
        type: 'danger',
        title: Lang.get('js/src/functions/MoedaEstrangeira.ops'),
        message: Lang.get('js/src/functions/MoedaEstrangeira.ops_message'),
      });
    })
    .always(function () {
      nifty.body.overlay('hide');
      setTimeout(() => {
        $('#scroll-top').trigger('click');
      });
    })
}

/**
 * Aplicar o valor de taxa para todas as inputs
 * de taxa que estão no agrupador que esta input
 * perctece, e também aplicar o valor total de
 * cada uma das despesas que estão neste agrupador
 *
 * @param  {event} event
 */
function handlerInputExchangeGroup(event) {
  const inputGroupRate = event.target;
  const idGroupRate = inputGroupRate.dataset.expenseGroup;
  const rows = document.querySelectorAll(`[data-expense-row-group="${idGroupRate}"]`);
  const groupRateValue = (inputGroupRate.value.length < 5)
    ? stringToInt(inputGroupRate.value)
    : stringToFloat(inputGroupRate.value);

  rows.forEach((currentRow, event) => {
    const inputRate = currentRow.querySelector('[data-expense-exchange-rate]');
    const inputTotalAmmount = currentRow.querySelector('[data-expense-total-ammount]');
    const expenseValue = stringToFloat(currentRow.dataset.expenseValue);
    const valueRate = groupRateValue;

    if (inputRate.disabled) {
      return;
    }

    if (inputGroupRate.value == '') {
      inputRate.value = '';
      inputTotalAmmount.value = '';
      return;
    }

    inputRate.value = groupRateValue;
    $(inputRate).val((groupRateValue).toFixed(decimalPlaces).replace('.', ','));
    $(inputTotalAmmount).val((expenseValue * valueRate).toFixed(decimalPlaces).replace('.', ','));
  });
}

/**
 * Como callback do evento de keyup na input de
 * taxa, calcula o valor total da despesa após
 * receber o valor da taxa, e apresenta o valor
 * na input de valor total
 *
 * @param  {event} event
 */
function handlerInputExchangeRate(event) {
  const inputRate = event.target;
  const idExpenseRow = inputRate.dataset.expenseRow;
  const expenseRow = document.getElementById(idExpenseRow);
  const inputTotalAmmount = expenseRow.querySelector('[data-expense-total-ammount]');

  if (inputRate.value == '') {
    inputTotalAmmount.value = '';
    return;
  }

  // calc
  const valueRate = (inputRate.value.length < 5)
    ? stringToInt(inputRate.value)
    : stringToFloat(inputRate.value);

  const expenseValue = stringToFloat(expenseRow.dataset.expenseValue);
  $(inputTotalAmmount).val(roundValue(valueRate, expenseValue, '*'));
}

/**
 * Como callback do evento de keyup na input de
 * total da despesa, calcula o valor da taxa após
 * receber o valor total da despesa, e apresenta
 * o valor na input de taxa
 *
 * @param  {event} event
 */
function handlerInputExchangeTotalAmmount(event) {
  const inputTotalAmmount = event.target;
  const idExpenseRow = inputTotalAmmount.dataset.expenseRow;
  const expenseRow = document.getElementById(idExpenseRow);
  const inputRate = expenseRow.querySelector('[data-expense-exchange-rate]');

  if (inputTotalAmmount.value == '') {
    inputRate.value = '';
    return;
  }

  // calc
  const totalAmmuntValue = stringToFloat(inputTotalAmmount.value);
  const expenseValue = stringToFloat(expenseRow.dataset.expenseValue);
  $(inputRate).val(roundValue(totalAmmuntValue, expenseValue, '/'));
}

/**
 * Identificar a linha do botão clicado, e habilitar
 * a edição das inputs de taxa e valor total para esta
 * linha, ocultando o botão de desbloqueio após isso
 *
 * @param  {event} event
 */
function handlerEnableEditExchange(event) {
  const button = event.target.closest('button');
  const idRow = button.dataset.expenseRow;
  const rowElement = document.getElementById(idRow);
  const inputs = rowElement.querySelectorAll('input');

  inputs.forEach((currentInput) => {
    currentInput.disabled = false;
  });

  const baseClass = 'btn--exchange-rate-edit';
  button.classList.remove(`${baseClass}--enabled`);
  button.classList.add(`${baseClass}--disabled`);
}

/**
 * Transformar string em uma número com ponto
 * flutuante de 5 casas decimais
 *
 * @param  {string} stringNumber
 *
 * @return {float}
 */
function stringToFloat(stringNumber) {
  const number = parseInt(stringNumber.replace(/(\.|\,)/g, ''));
  return (number / 100000);
}

function stringToInt(stringNumber) {
  return parseInt(stringNumber.replace(/(\.|\,)/g, ''));
}

/**
 * Verifica se a tecla digitada é uma tecla
 * numérica ou a tecla backspace
 *
 * @param  {event} event
 *
 * @return {boolena}
 */
function validKeyPress(event) {
  return event.which == 8
    || (event.keyCode >= 48 && event.keyCode <= 57)
    || (event.keyCode >= 96 && event.keyCode <= 105);
}

/**
 * Realiza o balanceamento de término
 * do evento para apenas então disparar
 * o evento
 *
 * @param  {event}   event
 * @param  {callback} callback
 */
function keyupEvent(event, callback) {
  clearTimeout(keyupTimer);
  keyupTimer = setTimeout(function () {
    callback(event);
  }, 300);
}

/**
 * Aplicar na input o valor dela, utilizando
 * o jquery mask
 *
 * @param  {element} currentInput
 */
function applyValue(currentInput) {
  const value = currentInput.dataset.value;
  if (value != undefined && value != null && value != '') {
    $(currentInput).val(stringToFloat(value).toFixed(decimalPlaces).replace('.', ','));
  }
}

/**
 * Definir nas despesas que deram erro de validação
 * o mesmo valor que havia sido informado no momento
 * do erro
 *
 * @param  {Object} valoresComErro
 */
function defineBackValuesWithError(valoresComErro) {
  Object.entries(valoresComErro).forEach(([key, value]) => {
    const inputRate = document.querySelector(`input[name="taxaCambio[${key}]"]`);
    const inputTotalValue = document.querySelector(`input[name="valorTotal[${key}]"]`);
    const buttonEnableEdit = document.querySelector(`button[data-expense-row="${key}"]`);

    inputRate.dataset.value = value.taxaCambio;
    inputTotalValue.dataset.value = value.valorTotal;

    inputRate.disabled = false;
    inputTotalValue.disabled = false;

    const baseClass = 'btn--exchange-rate-edit';
    buttonEnableEdit.classList.remove(`${baseClass}--enabled`);
    buttonEnableEdit.classList.add(`${baseClass}--disabled`);
  });
}

function checkBlockedGroupExchangeInput(input) {
  const panelExpenses = input.closest('.panel-with-hint');
  const editButtons = panelExpenses.querySelectorAll('[data-expense-enable-edit="true"]');
  const inputsWithoutExchange = panelExpenses.querySelectorAll('[data-expense-exchange-rate]:not(:disabled');

  if (!editButtons.length && !inputsWithoutExchange.length) {
    input.classList.add('hidden');
  }
  return false;
}

/**
 * Enviar a request para salvar o
 * valor das taxas
 *
 * @param  {element} form
 *
 * @return {$.ajax}
 */
function sendRequest(form) {
  return $.ajax({
    method: 'POST',
    url: form.getAttribute('action'),
    data: $(form).serialize()
  });
}

/**
 * calcula e arredonda o valor que será exibido nos inputs
 * ex: 14.98000 / 3.20 = 4.68125 arredonda para 4.6813
 * ex: 14.9798 / 3.20 = 4.6811875 arredonda para 4.6812
 *
 * 3.20 = valor da despesa
 * 14.98000 e 14.9798 = valor total convertido(BRL)
 * 4.6813 e 4.6812 = valor taxa cambial
 *
 * @param  float inputValue
 * @param  float expenseValue
 * @param  String operator
 *
 * @return float
 */
function roundValue(inputValue, expenseValue, operator) {
  let value;
  let absValue;
  //valor de precisão do calculo, para identificar quantas casas decimais
  //teremos no final do calculo
  const precision = Math.pow(10, 5);

  //valores são multiplicados pela precisão porque na hora do calculo
  //se o numero conter ',' o arredondamento pode dar errado
  //ex1: 14.9800 / 3.20 = 4.6812499999999995 (apenas no JS)
  //ex2: 149800 / 320 = 4.68125
  //no ex1 arredondaria para baixo (4.6812) e daria diferente do valor do
  //arredondamento do php, o que faria retornar erro de valores diferentes
  //no ex2 arredonda para 4.6813 e fica igual no php
  inputValue = inputValue * precision;
  expenseValue = expenseValue * precision;

  // se o usuario informar o valor total ele precisa dividir para encontrar o
  // valor da taxa cambial
  if (operator === '/') {
    value = inputValue / expenseValue;

    // valor é multiplicado antes de arredondar porque a função round arrendonda
    // todas as casas decimais
    absValue = Math.abs(value * precision);

    let correctValue = String(absValue / precision).split('.');
    correctValue = correctValue[0] + ',' + correctValue[1].substring(0, 5);
    // retorna o valor que é dividido pela precisão para voltar as casas decimais
    // e caso o numero tenha menos que 4 casas decimais o toFixed acrescenta 0
    return correctValue;
  }

  // se o usuario informar o valor da taxa cambial multiplica para encontrar o
  // valor total
  value = expenseValue * inputValue;

  // valor é dividio antes de arredondar porque a função round arrendonda
  // todas as casas decimais
  absValue = Math.abs(Math.round(value / precision));
  // retorna o valor que é dividido pela precisão para voltar as casas decimais
  // e caso o numero tenha menos que 4 casas decimais o toFixed acrescenta 0
  return (absValue / precision).toFixed(decimalPlaces).replace('.', ',');
}

module.exports = {
  init: MoedaEstrangeira,
  url: /^\/admin\/moeda-estrangeira/
};
